import { isEmpty } from '@ember/utils';

import { Transform } from '@warp-drive/legacy/serializer/transform';
import { TrackedObject } from 'tracked-built-ins';

export default class JsonTransform extends Transform {
  deserialize(serialized) {
    if (isEmpty(serialized)) {
      return new TrackedObject({});
    } else {
      return new TrackedObject(serialized);
    }
  }

  serialize(deserialized) {
    if (isEmpty(deserialized)) {
      return {};
    } else {
      return deserialized;
    }
  }
}
